import { GREATER_THAN } from 'common/constants/messages/validations';
import { RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER } from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getNumberValue, getObjectValue } from 'utilities';
import { CustomValidationsParams } from './types';

const customValidations = (params: CustomValidationsParams) => {
  const { cell, addFeedbackFromCell, removeFeedbackFromCell } = params;
  const { alias, columnLegend } = getObjectValue(cell);

  if (alias === RANGE_SENSITIVITY_SPREADSHEET_COMPANY_SECTION_HEADER && columnLegend === 'A' && cell) {
    const raw = getNumberValue(cell.value as number | string | null | undefined);
    const feedback = GREATER_THAN(0);

    // This field drives lower/upper bound formulas and the save payload, so we surface
    // invalid values directly on the source cell to block save instead of silently ignoring them.
    if (raw <= 0) {
      addFeedbackFromCell?.(cell, feedback);
      return;
    }

    removeFeedbackFromCell?.(cell, feedback);
  }
};

export default customValidations;
